<div class="dialog-container">
    <div class="dialog-header">
        <h2>Seleccione sucursal</h2>
        <p>Elija el contexto para su jornada laboral</p>
    </div>

    @if (branches().length > 0) {
    <div class="branches-grid">
        @for (branch of branches(); track branch.id) {
        <div class="branch-card" [class.selected]="selectedId() === branch.id" (click)="select(branch.id)">

            <div class="icon-wrapper" [ngClass]="getCategoryColor(branch.category)">
                <mat-icon>{{ getCategoryIcon(branch.category) }}</mat-icon>
            </div>

            <div class="branch-info">
                <span class="name">{{ branch.name }}</span>
                <span class="address">{{ branch.address }}</span>
            </div>

            <mat-icon class="check-icon" [class.visible]="selectedId() === branch.id">check_circle</mat-icon>
        </div>
        }
    </div>

    } @else {
    <div class="p-12 text-center text-slate-500">
        <mat-icon class="text-4xl mb-2 opacity-20">location_off</mat-icon>
        <p>No se encontraron sucursales asignadas.</p>
    </div>
    }
</div>